<template>
  <div>
    <v-card-text>
      <v-autocomplete
        v-if="this.sexesOptions !== null"
        v-model="selectedSexes"
        :items="translateSexes"
        chips
        clearable
        deletable-chips
        dense
        multiple
        :label="this.$i18n.tc('select_modality_of_sex', 2)"
        @change="sexesChoice()"
      >
      </v-autocomplete>
    </v-card-text>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "SexesForm",
  components: {},
  data: function() {
    return {
      sexesOptions: [],
      selectedSexes: [],
      error: null
    };
  },
  computed: {
    translateSexes: function() {
      const val = this;
      const res = this.sexesOptions.map(function(e) {
        return {
          value: e,
          text: val.$i18n.tc("sex_modality." + e, 0)
        };
      });
      return res;
    }
  },
  methods: {
    availableSexes: function() {
      this.error = false;
      axios
        .get("bcmd/r/sexes", {
          params: {}
        })
        .then(response => {
          this.sexesOptions = response.data;
          this.selectedSexes = [this.sexesOptions[2]];
        })
        .catch(() => {
          this.error = true;
        });
    },
    sexesChoice: function() {
      this.$emit("update-sex", this.selectedSexes);
      return true;
    }
  },
  beforeMount() {
    this.availableSexes();
  }
};
</script>
